module.exports = __webpack_public_path__ + "0c6d0ba84fca3bf61fe3ffab8e76a782.svg";